import { Component, Prop, Watch } from "vue-property-decorator";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import Vue from "vue";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Client } from "@/modules/CupsPriceLevels/models/Clients";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { CUPS_PRICE_LEVEL_CONSTANTS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { nanoid } from "nanoid";
import { PreventKey } from "@/shared/mixins/mixins";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import lodash from "lodash";
import SaveList from "@/modules/List/components/SaveList/SaveList.vue";

Vue.use(Vuetify);
@Component({
  name: "AddClients",
  components: {
    DynamicSelect,
    SaveList
  }
})
export default class AddClients extends PreventKey {
  @Prop() private clients!: Client;
  @Prop() isEditing!: boolean;
  @Prop() private indexEditing!: string;
  @Prop() listClients!: { id: string; name: string; code: string }[];

  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  btnRoundClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  btnClassSecondary = STYLE_CLASSES.SECONDARY_BTN;
  btnRoundClassSecondary = STYLE_CLASSES.SECONDARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  pageTitle = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_CLIENT;
  CUPS_NAME = CUPS_PRICE_LEVEL_CONSTANTS.LABEL.NAME;
  CUPS_PRICE = CUPS_PRICE_LEVEL_CONSTANTS.LABEL.PRICE;
  addClientButton = CUPS_PRICE_LEVEL_CONSTANTS.BUTTON.ADD_CLIENTS;

  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  requiredFieldSelect = [FORM_VALIDATORS.REQUIRED_FIELD];
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  requiredNumberField = [FORM_VALIDATORS.REQUIRED_NUMBER_FIELD];
  greaterThanZero = FORM_VALIDATORS.GREATER_THAN_ZERO;
  integerDecimalField = FORM_VALIDATORS.INTEGER_AND_DECIMAL_NUMBER_FIELD;

  formClient = false;

  price = 0;

  LIST_CLIENTS_ID = CUPS_PRICE_LEVEL_CONSTANTS.LIST_CLIENTS_ID;
  clientsSelectModel: { id: string; name: string; code?: string }[] = [
    { id: "", name: "" }
  ];
  clientsSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.CUPS_NAME,
    hideDetails: false,
    required: true
  };
  showModalAddList = false;
  LABEL_ADD_CLIENT = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_CLIENT;

  mounted() {
    this.onPropertyChanged();
  }

  @Watch("indexEditing")
  onPropertyChanged() {
    this.clientsSelectConfig.listAll = lodash.cloneDeep(this.listClients);
    if (this.isEditing) {
      this.clientsSelectModel = this.clientsSelectConfig.listAll.filter(
        e => e.id == this.clients[this.indexEditing].name
      );
      this.price = this.clients[this.indexEditing].price;
      this.pageTitle = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_EDIT_CLIENT;
    } else {
      this.clientsSelectModel = [{ id: "", name: "" }];
      this.price = 0;
      this.pageTitle = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_CLIENT;
    }
  }

  get indexEditingProp() {
    return this.indexEditing;
  }

  addClient() {
    console.log("this.clientsSelectModel", this.clientsSelectModel);
    const nameValue = this.clientsSelectModel[0].name.trim() || "";
    if (this.isEditing) {
      if (this.validateClientRepeated(nameValue, 1, this.indexEditing)) {
        this.clients[this.indexEditing] = {
          price: this.price,
          name: this.clientsSelectModel[0].name.trim()
        };

        if (this.clientsSelectModel[0].code) {
          this.clients[
            this.indexEditing
          ].code = this.clientsSelectModel[0].code;
        }

        this.$emit(CUPS_PRICE_LEVEL_CONSTANTS.EMIT.EVENT_FORM_EDIT, true);
      } else {
        Snackbar.popError(CUPS_PRICE_LEVEL_CONSTANTS.MESSAGE.CLIENT_REPEATED);
        return false;
      }
    } else {
      if (this.validateClientRepeated(nameValue, 0, "")) {
        const key = `c${nanoid(8)}t`;
        this.clients[key] = {
          name: this.clientsSelectModel[0].name.trim(),
          price: this.price
        };

        if (this.clientsSelectModel[0].code) {
          console.log("llego", this.clientsSelectModel[0].code);
          this.clients[key].code = this.clientsSelectModel[0].code;
        }

        this.$emit(CUPS_PRICE_LEVEL_CONSTANTS.EMIT.EVENT_FORM_EDIT, true);
      } else {
        Snackbar.popError(CUPS_PRICE_LEVEL_CONSTANTS.MESSAGE.CLIENT_REPEATED);
        return false;
      }
    }
    this.close();
  }

  close() {
    this.clientsSelectModel = [{ id: "", name: "" }];
    this.price = 0;
    this.$emit(CUPS_PRICE_LEVEL_CONSTANTS.EMIT.CLOSE_ADD_CLIENT);
  }

  validateClientRepeated(nameClient: string, action: number, indice?: string) {
    if (nameClient != undefined) {
      const validateName = nameClient?.toLowerCase();

      for (const item in this.clients) {
        const stringCondition = this.clients[item].name;

        if (action == 0) {
          if (stringCondition?.toLowerCase() == validateName) {
            return false;
          }
        } else {
          if (
            stringCondition?.toLowerCase() == validateName &&
            indice != item
          ) {
            return false;
          }
        }
      }
    }

    return true;
  }

  onCloseListModal() {
    this.$emit(CUPS_PRICE_LEVEL_CONSTANTS.EMIT.CLOSE_ADD_LIST);
    this.showModalAddList = false;
  }

  addElementToClientList() {
    this.showModalAddList = true;
  }
}
